import HomePage from "../pages/HomePage";
import Login from "../pages/Login";
import Equipments from "../pages/Equipments";
import SideBar from "../components/Sidebar";
import Users from "../pages/Users";
import ProjectDetails from "../pages/ProjectDetails";
import UserDetails from "../pages/UserDetails";
import CrewManagement from "../pages/AddCrew";
import AllCrewsManagement from "../pages/AllCrewsManagement";
import NotFound from "../components/NotFound";
import TimeSheet from "../pages/TimeSheet";
import TimeCards from "../pages/TimeSheetStatus";
import TimeCard from "../pages/TimeCard";
import RoleSelect from "../pages/RoleSelect";
import ReviewTimeSheet from "../pages/ReviewTimeSheet";
import ReviewTimeCard from "../pages/ReviewTimeCard";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ProcessTimeSheet from "../pages/ProcessTimeSheet";
import ForgetPassword from "../pages/ForgetPassword";
import ChangePassword from "../pages/ChangePassword";
import CustomerReport from "../pages/CustomerReport";
import UnitJob from "../pages/UnitJob";
import ProjectCheckList from "../pages/ProjectCheckList";
import UnitJobReport from "../pages/UnitJobReport";
import MetabaseReport from "../pages/Reports";
import ManageChecklist from "../pages/ManageChecklist";

const user_id = localStorage.getItem("user_id");

export const LOGIN_ROUTES = {
  LOG_IN: {
    path: "/",
    element: <Login />,
    availability: ["all"],
  },
  FORGOT_PASSWORD: {
    path: "/forget-password",
    element: <ForgetPassword />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/" replace />,
    availability: ["all"],
  },
};

export const RESET_PASSWORD_ROUTES = {
  RESET_PASSWORD: {
    path: "/reset_password/:token?",
    element: <ChangePassword />,
    availability: ["all"],
  },
  ACTIVATE_ACCOUNT: {
    path: "/activate_account/:token?",
    element: <ChangePassword />,
    availability: ["all"],
  },
  // NOTFOUND: {
  //   path: "*",
  //   element: <Navigate to="/reset_password/:token?" replace />,
  //   availability: ["all"],
  // },
};

export const ROUTES = {
  HOME: {
    path: "/projects",
    element: <HomePage />,
    availability: ["all"],
  },
  FORGET_PASSWORD: {
    path: "/forget-password",
    element: <ForgetPassword />,
    availability: ["all"],
  },
  CHANGE_PASSWORD: {
    path: "/reset_password/:token?",
    element: <ChangePassword />,
    availability: ["all"],
  },
  ACTIVATE_ACCOUNT: {
    path: "/activate_account/:token?",
    element: <ChangePassword />,
    availability: ["all"],
  },
  TIME_SHEET: {
    path: "/time-sheet",
    element: <TimeCards />,
    availability: ["all"],
  },
  USERS: {
    path: "/users",
    element: <Users />,
    availability: ["all"],
  },
  PROJECT_DETAILS: {
    path: "/project-details/:id?",
    element: <ProjectDetails />,
    availability: ["all"],
  },
  USERDETAILS: {
    path: "/user-details/:id?",
    element: <UserDetails />,
    availability: ["all"],
  },
  CREW: {
    path: "/crew-management/:crewId",
    element: <CrewManagement />,
    availability: ["all"],
  },
  CREW_MANAGEMENT: {
    path: "/all-crews-management",
    element: <AllCrewsManagement />,
    availability: ["all"],
  },
  TIME_CARD: {
    path: "/timesheet-card/:id",
    element: <TimeCard />,
    availability: ["all"],
  },
  ROLE_SELECT: {
    path: "/role-select/:id?",
    element: <RoleSelect />,
    availability: ["all"],
  },
  REVIEW_TIMESHEET: {
    path: "/review-timesheet/:id?",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  PROCESS_TIMESHEET: {
    path: "/process-timesheet",
    element: <ProcessTimeSheet />,
    availability: ["all"],
  },
  CUSTOMER_REPORT: {
    path: "/customer-report",
    element: <CustomerReport />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  MANAGE_CHECKLIST: {
    path: "/manage-checklist",
    element: <ManageChecklist />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT: {
    path: "/unit-job-report",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT_WITH_CHECKLIST: {
    path: "/unit-job-report/:project_checklist_id",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  METABASE_REPORT: {
    path: "/reports/:id",
    element: <MetabaseReport />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/time-sheet" replace />,
    availability: ["all"],
  },
};

export const OPS_MANAGER_ROUTES = {
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT: {
    path: "/unit-job-report",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT_WITH_CHECKLIST: {
    path: "/unit-job-report/:project_checklist_id",
    element: <UnitJobReport />,
    availability: ["all"],
  },
   METABASE_REPORT: {
    path: "/reports/:id",
    element: <MetabaseReport />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/review-timesheet" replace />,
    availability: ["all"],
  },
};

export const FOREMAN_ROUTES = {
  TIME_SHEET: {
    path: "/time-sheet",
    element: <TimeCards />,
    availability: ["all"],
  },
  TIME_CARD: {
    path: "/timesheet-card/:id",
    element: <TimeCard />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/time-sheet" replace />,
    availability: ["all"],
  },
};

export const GENERAL_FOREMAN_ROUTES = {
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  CREW_MANAGEMENT: {
    path: "/all-crews-management",
    element: <AllCrewsManagement />,
    availability: ["all"],
  },
  CREW: {
    path: "/crew-management/:crewId",
    element: <CrewManagement />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT_WITH_CHECKLIST: {
    path: "/unit-job-report/:project_checklist_id",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  METABASE_REPORT: {
    path: "/reports/:id",
    element: <MetabaseReport />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/review-timesheet" replace />,
    availability: ["all"],
  },
};

export const FOREMAN_AND_GENERAL_FOREMAN_ROUTES = {
  TIME_SHEET: {
    path: "/time-sheet",
    element: <TimeCards />,
    availability: ["all"],
  },
  TIME_CARD: {
    path: "/timesheet-card/:id",
    element: <TimeCard />,
    availability: ["all"],
  },
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  CREW_MANAGEMENT: {
    path: "/all-crews-management",
    element: <AllCrewsManagement />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  CREW: {
    path: "/crew-management/:crewId",
    element: <CrewManagement />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT_WITH_CHECKLIST: {
    path: "/unit-job-report/:project_checklist_id",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  METABASE_REPORT: {
    path: "/reports/:id",
    element: <MetabaseReport />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/time-sheet" replace />,
    availability: ["all"],
  },
};

export const GENERAL_FOREMAN_AND_OPS_MANAGER_ROUTES = {
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT: {
    path: "/unit-job-report",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  UNIT_JOB_REPORT_WITH_CHECKLIST: {
    path: "/unit-job-report/:project_checklist_id",
    element: <UnitJobReport />,
    availability: ["all"],
  },
  METABASE_REPORT: {
    path: "/reports/:id",
    element: <MetabaseReport />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/review-timesheet" replace />,
    availability: ["all"],
  },
};

export const FOREMAN_AND_OPS_MANAGER_ROUTES = {
  TIME_SHEET: {
    path: "/time-sheet",
    element: <TimeCards />,
    availability: ["all"],
  },
  TIME_CARD: {
    path: "/timesheet-card/:id",
    element: <TimeCard />,
    availability: ["all"],
  },
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/time-sheet" replace />,
    availability: ["all"],
  },
};

export const NO_DATA_ROUTES = {
  NO_DATA: {
    path: "/no-data",
    element: <NotFound />,
    availability: ["all"],
  },
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/no-data" replace />,
    availability: ["all"],
  },
};

// Supplemental timesheet-viewing routes for checklist approvers. Rendered on
// top of a crew role's own route set when that role lacks /review-timesheet
// (currently only Foreman) — see src/routes/index.js. No wildcard here so the
// base role's NOTFOUND redirect stays in charge.
export const CHECKLIST_APPROVER_REVIEW_ROUTES = {
  REVIEW_TIMESHEET: {
    path: "/review-timesheet",
    element: <ReviewTimeSheet />,
    availability: ["all"],
  },
  REVIEW_TIMECARD: {
    path: "/review-timecard/:id/:crew_id?",
    element: <ReviewTimeCard />,
    availability: ["all"],
  },
};

export const CHECKLIST_APPROVER_ROUTES = {
  PROJECT_CHECKLIST: {
    path: "/project-checklist",
    element: <ProjectCheckList />,
    availability: ["all"],
  },
  UNIT_JOB: {
    path: "/unit-job/:project_checklist_id?",
    element: <UnitJob />,
    availability: ["all"],
  },
  ...CHECKLIST_APPROVER_REVIEW_ROUTES,
  NOTFOUND: {
    path: "*",
    element: <Navigate to="/project-checklist" replace />,
    availability: ["all"],
  },
};
